import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	getPgAirwallexAccountsRequest,
	getPgLegalEntitiesRequest,
	getPgServicesRequest,
} from 'redux/reducers/pgSettings/reducer';
import {
	selectPgAirwallexAccounts,
	selectPgAirwallexAccountsLoading,
	selectPgLegalEntities,
	selectPgLegalEntitiesLoading,
	selectPgServices,
	selectPgServicesLoading,
} from 'redux/reducers/pgSettings/selectors';

/** Services of the gateway; loaded once per visit of a tab that needs them. */
export const usePgServices = () => {
	const dispatch = useDispatch();
	const services = useSelector(selectPgServices);
	const loading = useSelector(selectPgServicesLoading);

	useEffect(() => {
		dispatch(getPgServicesRequest());
	}, [dispatch]);

	return { services, loading };
};

/** Legal entities of the gateway; loaded once per visit of a tab that needs them. */
export const usePgLegalEntities = () => {
	const dispatch = useDispatch();
	const legalEntities = useSelector(selectPgLegalEntities);
	const loading = useSelector(selectPgLegalEntitiesLoading);

	useEffect(() => {
		dispatch(getPgLegalEntitiesRequest());
	}, [dispatch]);

	return { legalEntities, loading };
};

/** Airwallex accounts of the gateway; loaded once per visit of a tab that needs them. */
export const usePgAirwallexAccounts = () => {
	const dispatch = useDispatch();
	const accounts = useSelector(selectPgAirwallexAccounts);
	const loading = useSelector(selectPgAirwallexAccountsLoading);

	useEffect(() => {
		dispatch(getPgAirwallexAccountsRequest());
	}, [dispatch]);

	return { accounts, loading };
};
